import React, { Component } from 'react';
import GoalStyles from './Goal.cssmodule.less';
import classNames from 'classnames';

class CurriculumGoal extends Component {
    render() {
        const textContents = this.props.data.textContent.split('\n');
        return (
            <div className={GoalStyles.curriculum}>
                {/* 스텝박스 영역 - 학습시작 / 학습목표에는 내용기술 안함. */}
                <div className={GoalStyles.intro_top}>
                    <div className={GoalStyles.intro_inner}>
                        <div className={classNames(GoalStyles.cell, GoalStyles.question)}>
                            <div className={GoalStyles.thmb_group}>
                                <span className={GoalStyles.thmb}>&nbsp;</span>
                                <strong className={GoalStyles.title}>학습목표</strong>
                            </div>
                            무엇을 배울지 알아볼까요?
                        </div>
                    </div>
                </div>
                <div className={GoalStyles.body}>
                    <div className={GoalStyles.goal_subject}>
                        <div className={classNames(GoalStyles.cell, GoalStyles.thmb)}>&nbsp;</div>
                        <div className={GoalStyles.cell}>
                            {textContents.map((text, idx) => <span key={idx}>{text}<br/></span>)}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CurriculumGoal;



// WEBPACK FOOTER //
// ./components/Curriculum/Goal.js